import { apiInstance } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const wallet = {
  getApiTaxiJobById (id, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/serviceReceipt/ride/apiTaxiJobId/${id}`,
      params
    })
  }
}

export default wallet
